import {Injectable} from "@angular/core";
import {CityApi} from "../../src/app/shared/sdk/services/custom/City";

@Injectable()
export class CityUtils {

  constructor(protected cityApi: CityApi) {}

  public loadBySeoIdAndState(citySeoId: string, stateCode: string) {
    return this.cityApi.findOne({where: {'seo_id': citySeoId, 'state.code': stateCode.toLocaleUpperCase()}});
  }

  public loadCitiesByMinPopulation(population: number) {
    return this.cityApi.find({where: {
      population: {gte: population}
    }});
  }
}



// WEBPACK FOOTER //
// ./common/utils/cityutils.ts